goog.require('el8.template.multiuser_access.viewDocuments');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.viewDocuments = (function() {
    var that = {};
    var curPageStart = 1;
    var curPageEnd;
    var numPages;
    var NUM_PAGES_PER_LOAD = 10;
    var showingViewLog = true;
    var allowDirectSignup = false;
    var leadGenResponseId = null;
    var leadGenShown = false;
    var leadGenEnabled = false;

    function viewChart(faxCode, unauthUserId, authToken) {

        if (allowDirectSignup) {
            location.href = el8.service.urls.get('pageSignup', [faxCode]);
        } else {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('requestFaxVerification', [faxCode, unauthUserId, authToken]),
                data: JSON.stringify({}),
                async: true,
                success: function(data) {
                    if (!data.error) {
                        var url = el8.service.urls.get('pageVerificationCode', [faxCode, unauthUserId, authToken, data.fax_verification_id]);
                        location.href = url;
                    }
                }
            });
        }
    }

    function renderPages(fromPage, toPage, faxCode, unauthUserId, authToken) {
        var viewLink = el8.service.urls.get('renderPageLinkPrefix', [faxCode, unauthUserId, authToken]);

        for (var pn=fromPage; pn <= toPage; pn++) {
            var thumbHTML = el8.template.multiuser_access.viewDocuments.lhsThumb({
                pageNum: pn,
                viewPageLinkPrefix: viewLink,
                selected: false
            });

            var centerImageHTML = el8.template.multiuser_access.viewDocuments.centerPaneImage({
                pageNum: pn,
                viewPageLinkPrefix: viewLink
            });


            $('.lhs-thumb-list').append(thumbHTML);
            $('.center-pane').append(centerImageHTML);
        }
    }

    function showMorePagesLink() {

        var numPageLeft = numPages - curPageEnd;

        if (numPageLeft > 0) {
          if (numPageLeft === 1) {
            $('.more-pages-button').html('1 more page');
          } else {
            $('.more-pages-button').html(numPageLeft + ' more pages');
          }

          $('.more-pages').show();
        } else {
          $('.more-pages').hide();
        }
    }

    function renderMorePages(faxCode, unauthUserId, authToken) {
        curPageEnd = _.min([curPageStart+NUM_PAGES_PER_LOAD-1, numPages]);

        renderPages(curPageStart, curPageEnd, faxCode, unauthUserId, authToken);
        curPageStart = curPageEnd+1;

        showMorePagesLink();
    }

    function handleViewLogClick(event) {

       showingViewLog = !showingViewLog;

       if (showingViewLog) {
           $('.view-log-status').addClass('el8Expanded').removeClass('el8Collapsed');
           $('.view-log-entries').show();
       } else {
           $('.view-log-status').removeClass('el8Expanded').addClass('el8Collapsed');
           $('.view-log-entries').hide();
       }
       if (event) {
           event.preventDefault();
       }
       return false;
    }

    function handleLeadGenResponse(event, faxCode, unauthUserId, authToken, responseType, closeFloater) {

      if (closeFloater) {
        $('#lead-gen-floater').addClass("hidden");
      }

      $.el8_ajax({
        type: 'POST',
        url: el8.service.urls.get('submitLeadGenResponse', [faxCode, unauthUserId, authToken]),
        data: JSON.stringify({"response_type": responseType}),
        async: true,
        success: function(data) {
            if (!data.error) {
                leadGenResponseId = data.response_id;
            }
        },
        error: function(data) {
        }
      });
    }

    function submitNoDemoReason(event, faxCode, unauthUserId, authToken) {

      $('#lead-gen-floater').addClass("hidden");
      var reason = $('#no-demo-reason-input').val();
      $.el8_ajax({
        type: 'POST',
        url: el8.service.urls.get('submitNoDemoReason', [faxCode, unauthUserId, authToken, leadGenResponseId]),
        data: JSON.stringify({"reason": reason}),
        async: true,
        success: function(data) {
        },
        error: function(data) {
        }
      });
    }

    function showLeadGenDialog(event, collabPhotos, collabNames, linkUserId, userName, role) {
      if (!leadGenEnabled) {
         return;
      }
      if (leadGenShown) {
        return;
      }

      leadGenShown = true;

      var container = $('#lead-gen-floater');
      container.html(
        el8.template.multiuser_access.viewDocuments.leadGenFloater({
            collabPhotos: collabPhotos,
            collabNames: collabNames,
            linkUserId: linkUserId,
            userName: userName,
            role: role
        })
      );

      $('#floaterBackground').css({'height': '100%', 'width': '100%'});
      var s = $('.floaterDialog');
      s.css({'z-index': 30001, 'top': ($(window).height()-s.outerHeight(true))/4, 'left': ($(window).width()-s.outerWidth(true))/2});

      setTimeout(function() { $('#lead-gen-floater').removeClass('hidden'); }, 2000);
    }


    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }

        var readLogs = spec.readLogs;
        var collabPhotos = spec.collabPhotos;
        var collabNames = spec.collabNames;
        var linkUserId = spec.linkUserId;

        var unauthUserId = spec.unauthUserId;
        var faxCode = spec.faxCode;
        numPages = spec.numPages;
        var authToken = spec.authToken;
        var senderLastName = spec.senderLastName;
        var senderPhotoUrl = spec.senderPhotoUrl;
        allowDirectSignup = spec.allowDirectSignup;
        var userName = spec.userName;
        var role = spec.role;
        leadGenEnabled = spec.leadGenEnabled;

        var container = $('.main-content');

        container.html(
            el8.template.multiuser_access.viewDocuments.content({
                readLogs: readLogs,
                senderPhotoUrl: senderPhotoUrl,
                senderLastName: senderLastName,
                renderPageLinkPrefix: el8.service.urls.get('renderPageLinkPrefix', [faxCode, unauthUserId, authToken]),
                downloadPDFLink: el8.service.urls.get('pageDownloadPDF', [faxCode, unauthUserId, authToken]),
                printPDFLink: el8.service.urls.get('pagePrintPDF', [faxCode, unauthUserId, authToken])
            })
        );

        var content = container;

        renderMorePages(faxCode, unauthUserId, authToken);

        content.on('click', '.more-pages-button',  function(event) {
            renderMorePages(faxCode, unauthUserId, authToken);
        });
        content.on('click', '#view-chart',  function(event) {
            viewChart(faxCode, unauthUserId, authToken);
        });
        content.on('click', '.view-log',  function(event) {
            handleViewLogClick(event);
            if (leadGenEnabled) {
                showLeadGenDialog(event, collabPhotos, collabNames, linkUserId, userName, role);
            }
        });

        // lead-gen events
        content.on('click', '#demo-button',  function(event) {
            handleLeadGenResponse(event, faxCode, unauthUserId, authToken, 'demo', true);
            $('#lead-gen-demo-floater').removeClass("hidden");
            var container = $('#lead-gen-demo-floater');
            container.html(
              el8.template.multiuser_access.viewDocuments.leadGenDemoConfirmFloater({})
            );
            $('#floaterBackground').css({'height': '100%', 'width': '100%'});
            var s = $('.floaterDialog');
            s.css({'z-index': 30001, 'top': ($(window).height()-s.outerHeight(true))/4, 'left': ($(window).width()-s.outerWidth(true))/2});
            setTimeout(function() {  $('#lead-gen-demo-floater').addClass("hidden"); }, 2000);
        });
        content.on('click', '#no-demo-button',  function(event) {
            $('#lead-gen-buttons').addClass("hidden");
            $('#no-demo-reason-container').removeClass("hidden");
            handleLeadGenResponse(event, faxCode, unauthUserId, authToken, 'nodemo', false);
            $('#no-demo-reason-input').focus();
        });
        content.on('click', '#later-button',  function(event) {
            handleLeadGenResponse(event, faxCode, unauthUserId, authToken, 'later', true);
        });
        content.on('click', '#no-demo-reason-submit',  function(event) {
            submitNoDemoReason(event, faxCode, unauthUserId, authToken);
        });

        if (leadGenEnabled) {
            content.on('click', '#save-to-computer-link',  function(event) {
                showLeadGenDialog(event, collabPhotos, collabNames, linkUserId, userName, role);
            });
            content.on('click', '#print-link',  function(event) {
                showLeadGenDialog(event, collabPhotos, collabNames, linkUserId, userName, role);
            });
        }

        $('.view-log-entries').show();

        handleViewLogClick();

    };

    return that;

})();
